import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import type { ChildrenProps } from "@msuite/ui/types";
import { useNavigate } from "react-router";
import { useChatStore } from "@/components/chat/store";

/** Props Interface */
interface UserCardContextMenuProps extends ChildrenProps {
	userId: string | undefined;
}

export function UserCardContextMenu({ children, userId }: UserCardContextMenuProps) {
	/** Store */
	const chatStore = useChatStore();
	const { t } = useTranslation();

	/** Hooks */
	const navigate = useNavigate();

	/** Functions */
	function handleOnNavigate() {
		navigate(`/users/${userId}`);
	}

	/** Render */
	return (
		<Menu
			type="context-menu"
			items={() => [
				{
					label: t("general.information"),
					icon: icon("Info"),
					onClick: handleOnNavigate,
				},
				"divider",
				{
					label: t("chats.send_message"),
					icon: icon("MessagesSquare"),
					onClick: chatStore.handleOnOpen,
				},
			]}
		>
			{children}
		</Menu>
	);
}
